export { getBaseUrl, TOKEN_NAME };

const getBaseUrl = (): string => {
  const { REACT_APP_BASE_URL: bu } = process.env;
  if (!bu) throw new Error("'REACT_APP_BASE_URL' is falsy.");
  return bu;
};

const TOKEN_NAME = 'token';
